import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ArrowsHorizontal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.5575 19.9425L5.8725 17.25H21V15.75H5.8725L8.5575 13.0575L7.5 12L3 16.5L7.5 21L8.5575 19.9425ZM21 7.5L16.5 3L15.4425 4.0575L18.1275 6.75H3V8.25H18.1275L15.4425 10.9425L16.5 12L21 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ArrowsHorizontal.vue"]]);
